import { PromotionsDefault } from './PromotionsDefault';
import { LogoLayoutNavbar } from './../Home/components/LogoLayoutNavbar';

PromotionsDefault.Navbar = LogoLayoutNavbar;

export default PromotionsDefault;
